<style>
.hero-section {
  position: relative;
  width: 100%;
  height: 500px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition: background-image 1s ease-in-out;
}

@media only screen and (max-width: 850px) {
  html {
    font-size: 3.6111vw;
  }

  .hero-section {
    height: 36.231rem !important;
    min-height: unset !important;
  }

  .hero-section .home-banner {
    min-height: 42.692rem !important;
  }
}
</style>
<template>
  <!-- Hero Section -->
  <section
      :style="{
            backgroundImage: slides.length > 0 ? `url(${slides[currentSlide].backgroundImage})` : '',
        }"
      class="hero-section"
  >
    <div class="banner-cock-one">
      <img alt="Banner" src="@/assets/img/icons/banner-cock1.svg">
    </div>
    <div class="banner-shapes">
      <div class="banner-dot-one">
        <span></span>
      </div>
      <div class="banner-cock-two">
        <img alt="Banner" src="@/assets/img/icons/banner-cock2.svg">
        <span></span>
      </div>
      <div class="banner-dot-two">
        <span></span>
      </div>
    </div>
    <div class="container">
      <div class="home-banner">
        <div class="row align-items-center w-100">
          <div class="col-lg-7 col-md-10 mx-auto">
            <div v-if="slides.length > 0" class="section-search aos" data-aos="fade-up">
              <h1><span>EZB</span>Badminton</h1>
              <h4> {{ slides[currentSlide].title }}</h4>
              <p class="sub-info">{{ slides[currentSlide].content }}</p>
            </div>
          </div>
          <div class="col-lg-5">
            <div class="banner-imgs text-center aos" data-aos="fade-up">
              <img alt="Banner" class="img-fluid" src="@/assets/img/bg/banner-right.png">
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Hero Section -->

  <!-- How It Works -->
  <section class="section work-section">
    <div class="work-cock-img">
      <img alt="Icon" src="@/assets/img/icons/work-cock.svg">
    </div>
    <div class="work-img">

    </div>
    <div class="container">
      <div class="section-heading aos" data-aos="fade-up">
        <h2><span>EZB</span> Badminton</h2>
        <p class="sub-title">Quản lý giải đấu, thông tin vận động viên, xếp hạng vận động viên</p>
      </div>
      <div class="row justify-content-center ">
        <div v-for="item in BannerWork" :key="item.id" class="col-lg-4 col-md-6 d-flex">
          <div class="work-grid w-100 aos" data-aos="fade-up">
            <div class="work-icon">
              <div class="work-icon-inner">
                <img :src="require(`@/assets/img/icons/${item.Image}`)" alt="Icon">
              </div>
            </div>
            <div class="work-content">
              <h5>
                {{ item.Title }}
              </h5>
              <p>{{ item.Text }}</p>
              <router-link :to="item.Path" class="btn">
                {{ item.Click }} <i class="feather-arrow-right"></i>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /How It Works -->

</template>

<script>
import {getSlides} from '@/api/strapi/slide';
import BannerWork from '@/assets/json/banner-work.json'
import {useAuthStore} from "@/stores/auth";
import axios from 'axios';
import {getImageUrl} from '@/api/strapi/image';

export default {
  data() {
    const authStore = useAuthStore();
    return {
      authStore,
      BannerWork: BannerWork,
      slides: [],
      currentSlide: 0,
    }
  },
  async created() {
    await this.fetchSlides();
    this.startSlideshow();
  },
  methods: {
    async fetchSlides() {
      try {
        const response = await getSlides()
        this.slides = response.data.map((item) => ({
          title: item.title,
          content: item.content,
          backgroundImage: item.image
              ? getImageUrl(item.image.url)
              : ''
        }));

      } catch (error) {
        console.log('ERROR', error);
      }
    },
    startSlideshow() {
      setInterval(() => {
        this.currentSlide = (this.currentSlide + 1) % this.slides.length;
      }, 5000)
    }
  },
}
</script>

